/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-debugger */
/* eslint-disable no-unused-vars */
import * as React from "react";
import { Stepper, Step, StepLabel, useMediaQuery } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import Check from "@mui/icons-material/Check";
import { useState } from "react";
import KeepMountedModal from "./modal";
import { useEffect } from "react";

// Cores
const ORANGE_FORTIO = "#FF3100";
const COR_TEXTO = "#012443";
const COR_INATIVA = "#E0E0E0"; // Um cinza neutro para o fundo

// 1. CUSTOMIZANDO O CONECTOR (A LINHA)
const CustomConnector = styled(StepConnector)(({ theme }) => ({
  // Esconde o conector no modo vertical
  [`&.${stepConnectorClasses.vertical}`]: {
    display: "none",
  },
  // Estilos para o modo horizontal
  [`&.${stepConnectorClasses.horizontal}`]: {
    top: 20, // Alinha no meio do nosso ícone customizado (que terá 40px)
    left: "calc(-50% + 20px)",
    right: "calc(50% + 20px)",
  },
  // A linha em si
  [`& .${stepConnectorClasses.line}`]: {
    height: 8,
    border: 0,
    backgroundColor: COR_TEXTO,
    borderRadius: 4,
  },
  // Linha ATIVA
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    backgroundColor: COR_TEXTO,
  },
  // Linha COMPLETA
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    backgroundColor: COR_TEXTO,
  },
}));

// 2. CUSTOMIZANDO O ÍCONE (O CÍRCULO)
const CustomStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor: COR_INATIVA,
  zIndex: 1,
  color: COR_TEXTO,
  width: 40,
  height: 40,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "1.1rem",
  fontWeight: "bold",
  boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",

  // Estilo do ícone ATIVO
  ...(ownerState.active && {
    backgroundColor: ORANGE_FORTIO,
    color: "#fff", // Texto do número em branco
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  // Estilo do ícone COMPLETO
  ...(ownerState.completed && {
    backgroundColor: ORANGE_FORTIO,
    color: "#fff", // Cor do checkmark
  }),
}));

// Função que decide o que mostrar dentro do ícone
function CustomStepIcon(props) {
  const { active, completed, className, icon } = props;

  return (
    <CustomStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {completed ? <Check sx={{ fontSize: "1.5rem" }} /> : <span>{icon}</span>}
    </CustomStepIconRoot>
  );
}


const steps = [
  "Pendente de contratação",     
  "Em Análise de perfil",           
  "Em Análise do motorista" ,    
  "Contratado"   ,
  "Em trânsito" ,  
  "Entregue",
  "Finalizado"

]


// const steps = [
//   "Criado (Pendente)",                 // PENDING (loading)
//   "Indo para coleta",                  // HEADING_TO_PICKUP
//   "Aguardando carregamento",           // WAITING_LOADING
//   "Aguardando documentação",           // WAITING_DOCUMENTATION
//   "Carregamento finalizado",           // LOADING_COMPLETED
//   "Em trânsito",                       // IN_TRANSIT (unloading)
//   "Aguardando descarga",               // WAITING_UNLOADING
//   "Descarga finalizada"                // UNLOADING_COMPLETED
// ];

// 3. O COMPONENTE FINAL
export default function ModernStepper({propsStatus, onResult}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const parseStep = (value) => {
    if (value === null || value === undefined || value === "") return null;
    const parsed = Number(value);
    return isNaN(parsed) ? null : parsed;
  };

  const [activeStep, setActiveStep] = useState(() => parseStep(propsStatus));
  const [index, setIndex] = useState(() => parseStep(propsStatus));
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    console.log(propsStatus);
    setActiveStep(parseStep(propsStatus));
  }, [propsStatus]);


  /**
   * Função chamada quando um passo é clicado.
   * Atualiza o passo ativo e abre o modal para confirmação.
   * @param {number} index - O índice do passo clicado.
   */
  const handleStepClick = (index) => {
    console.log(propsStatus);
    // 1. Atualiza o passo ativo (como antes)
    console.log("Passo clicado:", index, "Label:", steps[index]);
    setIndex(index);

    // 2. Abre o modal
    handleOpen();
  };

  /**
   * Função chamada quando o modal é fechado.
   * Recebe um boolean com o resultado do modal (true para confirmar, false para cancelar).
   * Se o resultado for true, atualiza o passo ativo para o passo selecionado.
   * Se o resultado for false, não faz nada (mas por enquanto, vamos manter simples).
   * @param {boolean} value - O resultado do modal (true para confirmar, false para cancelar)
   */
  const handleModalResult = (value) => {


    if (value === true) {
      console.log(`CONFIRMADO para o passo: ${steps[activeStep]}`);
      setActiveStep(index);
    } else {
      console.log(`CANCELADO para o passo: ${steps[activeStep]}`);
    }
  };

  return (
    <>
      <Stepper
        activeStep={activeStep} // 'Em Trânsito'
        orientation={isMobile ? "vertical" : "horizontal"}
        // Remove o 'alternativeLabel' para o modo vertical funcionar bem
        alternativeLabel={!isMobile}
        // Conecta nosso conector customizado
        connector={<CustomConnector />}
        // Estiliza os Rótulos (texto)
        sx={{
          // No modo vertical, adiciona um espaçamento
          ...(isMobile && {
            "& .MuiStep-root": {
              marginBottom: "16px",
            },
          }),
          // Estilo do texto (label)
          "& .MuiStepLabel-label": {
            color: COR_TEXTO,
            fontWeight: 500,
            marginTop: "8px",
            // Rótulo ATIVO
            "&.Mui-active": {
              color: COR_TEXTO,
              fontWeight: 700,
            },
            // Rótulo COMPLETO
            "&.Mui-completed": {
              color: COR_TEXTO,
              fontWeight: 500,
            },
          },
        }}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel
              StepIconComponent={CustomStepIcon}
              onClick={() => handleStepClick(index)}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
        <KeepMountedModal
          // open={open}
          handleClose={handleClose}
          onResult={handleModalResult}
        />
      </Stepper>
    </>
  );
}




